import radiogroup_module_default from "./radiogroup.module.js";
import { RadioGroup } from "@mantine/core";
import { jsx } from "react/jsx-runtime";

//#region src/components/radio/RadioGroup.tsx
const RadioGroup$1 = ({ children, required, label, value, error, onBlur, onChange, onFocus, "data-testid": testId }) => {
	return /* @__PURE__ */ jsx(RadioGroup, {
		classNames: radiogroup_module_default,
		label,
		withAsterisk: required,
		value,
		onChange,
		error,
		onBlur,
		onFocus,
		"data-testid": testId,
		children
	});
};

//#endregion
export { RadioGroup$1 as RadioGroup };